import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { LanguageContext } from "../../../../contexts/LanguageContext";
import { translations } from "../../../../translations";

const LandingPageFooter = () => {
  const navigate = useNavigate();
  const { language } = useContext(LanguageContext);
  const t = translations[language];

  const handleLegalNavigation = (section) => {
    navigate(`/legal?section=${section}`);
  };

  return (
    <footer className="landing-footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>SocratesLab</h3>
          <p>{t.hero.tagline}</p>
          <div className="social-links">
            <a
              href="https://twitter.com/socrateslab"
              target="_blank"
              rel="noopener noreferrer"
            >
              Twitter
            </a>
            <a
              href="https://linkedin.com/company/socrateslab"
              target="_blank"
              rel="noopener noreferrer"
            >
              LinkedIn
            </a>
          </div>
        </div>

        <div className="footer-section">
          <h4>{t.contact.info}</h4>
          <p>260 rue France</p>
          <p>Saint-Philippe, Quebec</p>
          <p>Canada, J0L 2K0</p>
          <p>514-792-7385</p>
        </div>

        <div className="footer-section">
          <h4>{t.footer.legal}</h4>
          <button onClick={() => handleLegalNavigation("terms")}>
            {t.footer.terms}
          </button>
          <button onClick={() => handleLegalNavigation("privacy")}>
            {t.footer.privacy}
          </button>
          <button onClick={() => handleLegalNavigation("cookies")}>
            {t.footer.cookies}
          </button>
          <button onClick={() => handleLegalNavigation("gdpr")}>
            {t.footer.gdpr}
          </button>
          <button onClick={() => handleLegalNavigation("california")}>
            {t.footer.california}
          </button>
        </div>
      </div>
    </footer>
  );
};

export default LandingPageFooter;
